const Feedbacks = "/api/feedbacks";

const exportedObject = {
    Feedbacks,
};

export default exportedObject;
